// Minimal i18n dictionary — EN / DE / FR
// Keep keys short and grouped per surface.
import { deSupplement } from "./de-supplement";

export const LOCALES = [
  { code: "en", label: "EN", name: "English" },
  { code: "de", label: "DE", name: "Deutsch" },
  { code: "fr", label: "FR", name: "Français" },
];

export const translations = {
  en: {
    nav: {
      solutions: "Solutions",
      industries: "Industries",
      integrations: "Payments",
      cases: "Case Studies",
      pricing: "Pricing",
      blog: "Blog",
      configurator: "Configurator",
      contact: "Contact",
      talk: "Talk to sales",
      demo: "Book a demo",
      callback: "Request a callback",
    },
    hero: {
      eyebrow: "POS · KIOSK · ONLINE ORDERING · PAYMENTS",
      title_a: "The operating system for",
      title_restaurants: "restaurants",
      title_and: "and",
      title_retail: "retail",
      sub: "One platform for POS, self-order kiosks, QR ordering, online shop and payments. Built for speed, engineered for the floor.",
      cta_demo: "Book a demo",
      cta_kiosks: "Explore Kiosks",
      stat_live: "Live in",
      stat_uplift: "Avg uplift",
      stat_uptime: "Uptime",
      live_days: "5 days",
    },
    sections: {
      why_overline: "Why O'Javana",
      why_title: "Built like a tool, not a toy.",
      why_sub: "Every feature exists for a reason on the floor. No bloat, no \u201Cnice-to-haves,\u201D no waiting.",
      solutions_overline: "Solutions",
      solutions_title: "One platform.",
      solutions_title_2: "Seven revenue channels.",
      solutions_sub: "Mix and match modules. Everything talks to the POS — no double entry, no reconciliation nightmares.",
      kiosk_eyebrow: "Spotlight · Kiosk",
      kiosk_title_a: "Self-order kiosks that",
      kiosk_title_b: "pay back",
      kiosk_title_c: "in 6 weeks.",
      kiosk_sub: "Cut queues, lift average ticket 22% and free your team to do what software can't.",
      kiosk_cta: "Explore the Kiosk lineup",
      kiosk_cta2: "Book a kiosk demo",
      dashboard_overline: "Live preview",
      dashboard_title: "Look inside the cockpit.",
      dashboard_sub: "The same dashboard your team uses on shift. Orders, menu and analytics — one keystroke away.",
      industries_overline: "Industries",
      industries_title: "Tailored for your business type.",
      industries_sub: "From a 12-seat espresso bar to a 200-store retail group — same platform, different playbook.",
      integrations_overline: "Integrations",
      integrations_title: "Plays nicely with your stack.",
      integrations_sub: "Native connectors for payments, delivery, accounting and CRM — built and maintained by us.",
      testimonials_overline: "Trusted",
      testimonials_title: "Operators who run on O'Javana.",
      logos_trusted: "Trusted by 7,000+ operators across Europe",
    },
    demo: {
      eyebrow: "Book a free demo",
      title: "See it run on your menu in 30 minutes.",
      sub: "No slide deck. We pull up a sandbox with your menu, walk through POS + Kiosk + Online, and answer every question.",
      bullets: [
        "Tailored to your business type",
        "Hardware quote in the same call",
        "Live ROI calculator for kiosks",
        "Free onboarding scope on request",
      ],
      full_name: "Full name",
      business_name: "Business name",
      email: "Email",
      phone: "Phone",
      business_type: "Business type",
      locations: "# Locations",
      interested_in: "Interested in",
      message: "Message",
      submit: "Request demo",
      sending: "Sending...",
      consent: "By submitting you agree to our privacy notice.",
      success_title: "Got it. We're on it.",
      success_sub: "A specialist will reach out within 24 hours to confirm your demo slot.",
      success_again: "Submit another request",
      bt_restaurant: "Restaurant / Café",
      bt_retail: "Retail / Boutique",
      bt_kiosk: "QSR / Kiosk-led",
      bt_events: "Events / Pop-up",
      bt_other: "Other",
      time_2min: "~2 minutes",
    },
    callback: {
      eyebrow: "Request a callback",
      title: "Prefer we call you?",
      sub: "Drop your number and a specialist rings back at your preferred time.",
      full_name: "Full name",
      phone: "Phone",
      topic: "What's it about? (optional)",
      best_time: "Best time to call",
      asap: "ASAP",
      morning: "Morning",
      afternoon: "Afternoon",
      evening: "Evening",
      submit: "Request callback",
      success: "Thanks. We'll call you back shortly.",
    },
    footer: {
      tagline: "The all-in-one POS, Kiosk & Online Ordering platform engineered for restaurants and retail.",
      newsletter_ph: "you@business.com",
      subscribe: "Subscribe",
      solutions: "Solutions",
      company: "Company",
      product: "Product",
      get_started: "Get started",
      book_demo: "Book a demo",
      email_us: "Email us",
      vs_sumup: "vs SumUp",
      vs_paymash: "vs Paymash",
      privacy: "Privacy",
      terms: "Terms",
      imprint: "Imprint",
    },
    configurator: {
      title: "Hardware bundle configurator",
      sub: "Pick the hardware that fits your floor. Get a transparent quote in seconds — no sales call required.",
      total_hardware: "Hardware one-time",
      total_software: "Software / month",
      cta_save: "Save & email me this quote",
      cta_call: "Get a sales call on this bundle",
      placeholder_full_name: "Anna Müller",
      placeholder_business: "Café Pivot",
      placeholder_email: "you@business.com",
      saved: "Quote saved. Check your inbox.",
    },
    admin: {
      title: "Admin · Inbox",
      enter_token: "Password",
      token_label: "Password",
      token_help: "The browser can save this email and password.",
      inbox_help: "Demo requests, callbacks, quotes, and CMS pages. Email and password from the server .env.",
      offers_login_link: "Offers, vouchers, Mailco settings",
      email_label: "Email",
      password_label: "Password",
      sign_in: "Sign in",
      tab_demos: "Demo requests",
      tab_callbacks: "Callbacks",
      tab_contacts: "Contact messages",
      tab_quotes: "Configurator quotes",
      tab_pages: "Pages",
      logout: "Sign out",
      empty: "Nothing here yet.",
      mark_contacted: "Mark contacted",
      mark_qualified: "Mark qualified",
      mark_won: "Mark won",
      mark_lost: "Mark lost",
      invalid_token: "Invalid email or password.",
      invalid_credentials: "Invalid email or password.",
    },
    header: {
      home: "Home",
      product: "Product",
      industries: "Industries",
      offers: "Offers",
      see_all_products: "See all products",
    },
    footer_extra: {
      contact_us: "Contact us",
      offices: "Neuchâtel · Manchester · Freiburg",
      subscribed: "Subscribed.",
      could_not_subscribe: "Could not subscribe. Try again.",
      rights: "All rights reserved.",
      website_by: "Website by",
    },
    banner: {
      office_open: "Boudry office open · 08:00–19:00 CET",
    },
    neuchatel: {
      eyebrow: "Born in Switzerland",
      title_a: "Built in",
      title_b: "Neuchâtel",
      title_c: "for the Swiss market.",
      desc: "O'javana is operated from Boudry, Canton Neuchâtel, Switzerland. Our engineers, support agents and field technicians speak your language, know your market, and answer when you call.",
      stat_response: "Response",
      stat_response_value: "Same hour",
      stat_onsite: "On-site",
      stat_onsite_value: "Within 48h",
      stat_hosted: "Hosted",
      stat_hosted_value: "Swiss data centres",
      cta_talk: "Talk to a local specialist",
      cta_callback: "Request a callback",
      hq_label: "/hq · switzerland",
      hq_name: "Boudry",
      geo_line: "50 minutes from Bern · 90 minutes from Zürich and Geneva.",
      hours_label: "Office hours",
      hours_value: "08:00 – 19:00 CET",
      langs_label: "Languages",
      langs_value: "FR · DE · EN · IT",
    },
    whypage: {
      counter: "From Neuchâtel · 234 venues live",
      eyebrow: "Why O'javana",
      h1_a: "Easy to use,",
      h1_b: "cheaper",
      h1_c: ", efficient &",
      h1_d: "local support",
      h1_e: ".",
      intro: "Cheaper, non-local solutions save you a little — and make you tired. When something breaks, you chase them. With O'javana the team is in Switzerland, the phone gets picked up, and your floor keeps running.",
      cta_h2_a: "Visit our show room at",
      cta_h2_b: "Boudry",
      cta_h2_c: "today!",
      cta_body: "Drop by for a coffee at our office & experience the product in real action.",
      book_visit: "Book your visit",
      see_pricing: "See pricing",
      easy_title: "Easy to use",
      easy_body: "Train new staff in 12 minutes — not 12 days. Big tiles, clear flows, no manual to read. The kind of POS your weekend hire can run by lunch.",
      easy_p1: "Sub-second order entry",
      easy_p2: "12-minute staff onboarding",
      easy_p3: "Big touch tiles, no nested menus",
      easy_p4: "Same UI on POS, kiosk and handheld",
      cheaper_title: "Cheaper hardware",
      cheaper_body: "Starter at CHF 39/month with our terminal. Eligible merchants get the POS bundle and even the Self-Order Kiosk at zero up-front cost.",
      cheaper_p1: "CHF 0 hardware for eligible merchants",
      cheaper_p2: "0.90% card processing with our terminals",
      cheaper_p3: "23.8\" Self-Order Kiosk at CHF 1,980",
      cheaper_p4: "No per-feature unlocks, no setup fees",
      efficient_title: "Efficient",
      efficient_body: "Offline-first POS, real-time analytics and a kitchen handoff that doesn't depend on the cloud round-trip. Built for the floor at 8pm Friday.",
      efficient_p1: "Offline-first — never miss a sale",
      efficient_p2: "Real-time multi-location dashboard",
      efficient_p3: "Kitchen Display + Customer Display included",
      efficient_p4: "UberEats, QR & online — one ticket",
      local_title: "Local support",
      local_body: "Real humans in Neuchâtel — no overseas call-centre, no ticket queue, no week-long waits. Same-hour replies and on-site help within 48 hours.",
      local_p1: "Operated from Neuchâtel · Switzerland",
      local_p2: "Same-hour replies, same-day fixes",
      local_p3: "On-site help within 48 hours",
      local_p4: "Phone in FR · DE · EN · IT",
    },
    payments_page: {
      eyebrow: "Payments",
      h1: "Accept everything. Reconcile nothing.",
      intro_a: "Through our Swisspayout collaboration, every O'javana terminal, kiosk and online checkout takes cards, contactless, TWINT and the major mobile wallets — settled to a single account. For more details consult",
    },
    sitemap_page: {
      eyebrow: "Sitemap",
      h1: "Every page on O'javana.",
      intro: "One screen, every route. A useful reference for humans and a clean signal for search engines.",
      sec_discover: "Discover",
      sec_product: "Product",
      sec_industries: "Industries",
      sec_pricing_tools: "Pricing & Tools",
      sec_contact: "Contact",
      sec_legal: "Legal",
      lbl_home: "Home",
      lbl_why: "Why O'javana",
      lbl_about: "About",
      lbl_industries_all: "Industries",
      lbl_case_studies: "Case Studies",
      lbl_blog: "Blog",
      lbl_vs_ls: "vs Lightspeed",
      lbl_pos: "Point of Sale",
      lbl_kiosk: "Self-Order Kiosk",
      lbl_waiter: "Waiter App",
      lbl_qr: "QR Order & Pay",
      lbl_shop: "Online Shop",
      lbl_terminals: "Payment Terminals",
      lbl_loyalty: "Gift Cards & Loyalty",
      lbl_all_products: "All Products",
      lbl_qsr: "Quick Service",
      lbl_delivery: "Delivery Service",
      lbl_restaurants: "Restaurants & Cafés",
      lbl_grocery: "Grocery & Convenience",
      lbl_foodtruck: "Food Truck",
      lbl_franchise: "Franchise & Multi-brand",
      lbl_pricing: "Pricing",
      lbl_offers: "Offers",
      lbl_configurator: "Price configurator",
      lbl_payments: "Payments",
      lbl_contact: "Contact",
      lbl_callback: "Request a callback",
      lbl_book_demo: "Book a demo",
      lbl_imprint: "Imprint",
      lbl_privacy: "Privacy",
      lbl_terms: "Terms",
      lbl_sitemap: "Sitemap",
      sec_cities: "Cities — POS",
      sec_service_areas: "Service areas",
      sec_alternatives: "Alternatives",
      sec_seo_solutions: "Solutions (SEO)",
      lbl_pos_in: "POS",
      lbl_alt_suffix: "alternative",
    },
    contact_page: {
      eyebrow: "Contact",
      h1: "Talk to the people who built it.",
      intro: "Send us a note and a Swiss specialist will reach out within one business hour. Or call — we pick up.",
      address: "Rue Louis-Favre 12 · 2017 Boudry · Switzerland",
      time_hint: "~1 minute",
      f_full_name: "Full name",
      f_phone: "Phone",
      f_email: "Email",
      f_message: "Message",
      ph_full_name: "Anna Müller",
      ph_phone: "+41 79 000 00 00",
      ph_email: "you@business.com",
      ph_message: "Tell us about your business and how we can help.",
      agree: "By submitting you agree to our privacy notice.",
      send: "Send message",
      sending: "Sending...",
      success_title: "Got it.",
      success_body: "A specialist will respond within one business hour.",
      send_another: "Send another message",
      toast_success: "Thanks. We'll get back to you shortly.",
      toast_error: "Could not send. Try again.",
    },
    pricing_page: {
      eyebrow: "Pricing",
      h1_a: "One platform.",
      h1_b: "Unbeatable pricing.",
      intro_a: "No setup fees. No per-feature unlock. Card processing at",
      intro_b_with: "with O'javana payment terminals",
      intro_b_without: "on Starter without our terminal",
      banner_eligible: "Eligible merchants",
      banner_h2_a: "Free hardware if your card sales beat",
      banner_h2_amount: "CHF 20,000/mo",
      banner_h2_z: ".",
      banner_body: "Process more than CHF 20,000 in card payments per month and we ship your POS terminal, payment device, printer and cash drawer at zero up-front cost. On the Freedom plan, the 23.8\" Self-Order Kiosk is included on the same eligibility — paired with our",
      banner_rate_phrase: "0.90% special card processing rate",
      banner_pt1: "12-month commitment, fair-use replacement included",
      banner_pt2: "Eligibility reviewed monthly — no hidden fees",
      banner_pt3: "Switzerland, EU and Adyen-supported markets",
      banner_check: "Check my eligibility",
      banner_callback: "Request a callback",
      banner_bundle_caption: "Standard bundle: dual-screen POS, cash drawer, 80mm printer, EMV/NFC/TWINT terminal.",
      hw_sw_label: "hardware + software",
      toggle_terminal: "With O'javana payment terminal",
      toggle_terminal_caption: "−30 CHF / month · 0.90% card rate",
      toggle_yearly: "Yearly billing",
      toggle_yearly_caption: "2 months free · pay 10× monthly",
      most_chosen: "Most chosen",
      per_yr: "/yr",
      per_mo: "/mo",
      per_station: "· per station",
      with_term_save: "−CHF 30 with our terminal",
      two_months_free: "2 months free vs monthly",
      premium_kiosk_led: "Premium · Kiosk-led",
      freedom_meta: "/freedom · subscription",
      freedom_kiosk_note: "Kiosk hardware (23.8\") free for eligible merchants with CHF 20K+ monthly card sales using O'javana terminals.",
      freedom_cta: "Go Freedom",
      freedom_fixed: "Fixed bundle price · doesn't change with terminal",
      plan_includes: "All plans include unlimited orders, PCI & GDPR compliance, Swiss-hosted data, 30-day money-back guarantee and seamless updates. Self-Order Kiosk 23.8\" hardware:",
      plan_includes_unit: "per unit (or free with Freedom on eligibility).",
      kds_cds_footnote: "* Kitchen Display System (KDS) 15.6\" and Customer Display System (CDS) 10\" are available as optional add-ons across all plans, including Complete — CHF 480 (KDS) and CHF 220 (CDS) per unit.",
      addon_label: "Add-on hardware",
      addon_h2_a: "Self-Order Kiosk 23.8\" ·",
      addon_body: "Counter-top or floor-standing kiosk with TWINT-ready payment, receipt printer and barcode scanner. Free on the Freedom subscription with monthly card-sales eligibility.",
      addon_p1: "23.8\" multi-touch screen, anti-glare",
      addon_p2: "Built-in EMV/NFC/TWINT terminal",
      addon_p3: "Built-in 80mm receipt printer",
      addon_p4: "Built-in 1D/2D barcode scanner",
      addon_p5: "Kitchen Display System (KDS) 15.6\" · CHF 480",
      addon_cta_cfg: "Configure hardware bundle",
      addon_cta_kiosk: "Explore the Kiosk",
      starter_name: "Starter",
      starter_blurb: "Real cloud POS live this week. Take cards, run shifts, close clean.",
      starter_cta: "Start with Starter",
      grow_name: "Grow",
      grow_blurb: "Add the Waiter App and tableside ordering. The set-up most cafés need.",
      grow_cta: "Pick Grow",
      complete_name: "Complete",
      complete_blurb: "Multi-station, multi-location, every channel — the full operations cockpit.",
      complete_cta: "Get Complete",
      freedom_name: "Freedom",
      freedom_blurb: "Kiosk-led venues. Same Complete bundle plus the 23.8\" self-order kiosk — included.",
    },
    configurator_page: {
      hardware_label: "Hardware",
      important: "Important",
      tier_intro: "Your monthly card sales",
      with_term_label: "With O'javana payment terminal",
      with_term_caption: "License fee −CHF 39 / month per station",
      note_tier_rental: "Client has to maintain the mentioned sales for 6 consecutive months in order to keep the discounted price (or free material). The price of material paid will be reimbursed in the form of waived software license fees over an equivalent number of months, or as a voucher.",
      note_rate: "Optional monthly insurance + SIM card fees for payment terminals apply: CHF 29 / month for S1F2 and CHF 19 / month for AMS1, billed annually.",
      note_install: "Menu programming & on-site installation: one-time fee of CHF 380.",
      book_demo_link: "Or book a live demo →",
      free_label: "FREE",
      free_eligible: "free with eligible sales",
      stations_label: "stations",
      per_station_save: "−CHF 30 / station with terminal",
      bundle_label: "Add POS bundle",
      bundle_reset: "Reset bundle",
      bundle_caption: "POS · AMS1 terminal · Receipt Printer · Cash Drawer",
      bundle_only: "Free on POS bundle only",
      pos_bundle_table: "POS bundle",
      pos_bundle_table_caption: "Free at 100% tier · discounted with other tiers",
      optional_hw_table: "Optional hardware",
      optional_hw_table_caption: "Discounted at 30 / 40 / 50% tiers · full price at 100% tier",
      tier_t0: "Under CHF 5,000",
      tier_t1: "CHF 5,000 – 10,000",
      tier_t2: "CHF 10,000 – 15,000",
      tier_t3: "CHF 15,000 – 20,000",
      tier_t4: "CHF 20,000+",
      mobile_quote: "Quote",
      mobile_view_full: "Tap to view full quote",
    },
    offers: {
      nav: "Offers",
      eyebrow: "Limited-time promotions",
      h1: "Deals worth switching for.",
      intro: "Hand-picked O'javana offers — new-merchant discounts, free hardware, seasonal packages. Claim before they expire.",
      empty_title: "No live offers right now.",
      empty_body: "Check back soon — or book a demo and we'll build one for you.",
      free: "Free",
      view: "See offer",
      days_left: "{n} days left",
      all_offers: "All offers",
      details: "About this offer",
      terms: "Terms & conditions",
      valid_until: "Valid until {date}",
      other_offers: "Other live offers",
      not_found: "This offer doesn't exist.",
      expired_banner: "This offer is no longer available. Check our other offers.",
      check_others: "See live offers",
      claim_this_offer: "Claim this offer",
      full_name: "Your full name",
      email: "Your email",
      phone: "Phone number",
      business_name: "Business name (optional)",
      have_code: "Have a code?",
      voucher_ph: "Enter voucher (optional)",
      submit: "Send my request",
      sending: "Sending...",
      privacy_hint: "We only use your details to process this offer. Never sold or spammed.",
      success_title: "Thanks — request received.",
      success_body: "We'll get back to you within one business day with next steps.",
      popup_cta: "Grab this offer →",
      cta_headline: "To grab this offer, fill the form below.",
      cta_sub: "We'll confirm within one business day. Or, if you're ready, pay directly under the form.",
      or: "or",
      buy_now_title: "Prefer to buy this offer instantly?",
      buy_now_sub: "Pay by card or Apple Pay in a few seconds. Your data is protected by Adyen.",
      you_pay: "You pay",
      pay_now: "Buy now",
      buy_direct_headline: "Buy this offer instantly.",
      buy_direct_sub: "Enter your details below, pay with card or Twint, and we'll activate your offer.",
      your_details: "Your details",
      ask_pill: "Have a question?",
      ask_headline: "Not ready to buy yet? Fill the form below and we'll get back to you.",
      ask_sub: "Send us your questions or specific requirements — we reply within one business day.",
      claim_headline_no_pay: "To grab this offer, fill the form below.",
      claim_sub_no_pay: "We'll confirm within one business day with next steps.",
      fill_contact_first: "Please fill your name, email and phone first.",
      voucher_invalid: "Voucher not recognised — you can still submit without one.",
    },
    solutions_page: {
      eyebrow_all: "All solutions",
      h1_a: "Build the stack that fits",
      h1_b: "your floor.",
      intro: "Each module ships standalone or as part of the all-in-one suite. Mix what you need.",
      back: "← Back to solutions",
      book_demo: "Book a demo",
      configure_hardware: "Configure hardware",
      what_you_get: "What you get",
      pairs_with: "Pairs well with",
    },
    compare_page: {
      pill: "Swiss-made comparison",
      h1_a: "O'javana vs",
      h1_ls: "Lightspeed",
      h1_b: "We're the local, focused choice.",
      intro: "Lightspeed is a fine global suite. But if you run a Swiss restaurant or store, you don't need 200 features and a ticket queue — you need a POS that just works, with a team that picks up the phone.",
      side_by_side: "Side by side",
      full_picture: "The full picture.",
      vp_honest_title: "Honest pricing",
      vp_honest_body: "Starter at CHF 39/month with our terminal. No setup fees, no per-feature unlock, no surprise add-ons. Card processing at 0.90% with O'javana terminals.",
      vp_focused_title: "Focused product",
      vp_focused_body: "POS, kiosks, online, payments, gift cards & loyalty, inventory — that's it. No 200-feature menu you'll never use.",
      vp_local_title: "Local Swiss support",
      vp_local_body: "Same-hour replies. Same-day fixes. On-site within 48 hours. From a real team in Neuchâtel — not a global ticket queue.",
      vp_hw_title: "Hardware that's free for eligible merchants",
      vp_hw_body: "Process CHF 20,000+ in card sales per month? Your POS bundle, payment terminal and even the self-order kiosk ship at zero up-front cost.",
      dim: "Dimension",
      footnote: "Comparison reflects publicly available Lightspeed Retail / Restaurant pricing and hardware bundle pages at the time of writing. Your actual quotation may vary.",
      bottom_h2: "Want to switch from Lightspeed?",
      bottom_body: "We migrate your menu, products and reports for free. Installation within 48 hours, terminals shipped same day for eligible merchants.",
      bottom_cta: "Book a switch consultation",
      bottom_cta2: "See our pricing",
    },
    eligibility: {
      eyebrow: "30-second eligibility check",
      title: "Find your tier in 30 seconds.",
      subtitle: "Four quick questions — we'll suggest the plan, terminal discount, hardware bundle eligibility and your expected first-month invoice.",
      q1: "What are your monthly card sales?",
      q1_t0: "Under CHF 5,000",
      q1_t1: "CHF 5,000 – 10,000",
      q1_t2: "CHF 10,000 – 15,000",
      q1_t3: "CHF 15,000 – 20,000",
      q1_t4: "CHF 20,000+",
      q2: "How many POS stations?",
      q3: "Where is your venue?",
      q3_ch: "Switzerland",
      q3_eu: "EU (Adyen-supported)",
      q3_other: "Other",
      q4: "Do you already use a POS today?",
      q4_yes: "Yes, switching",
      q4_no: "No, brand new",
      result_eyebrow: "Recommended setup",
      result_plan: "Plan",
      result_terminal: "With O'javana payment terminal",
      result_bundle: "POS bundle hardware",
      result_invoice: "Expected first-month invoice",
      bundle_free: "Free for eligible merchants",
      bundle_paid: "CHF 1,065 one-time",
      bundle_freedom: "Free kiosk + POS bundle",
      ineligible: "We currently support Switzerland and Adyen-supported EU markets. Talk to us anyway — we'll find a partner for you.",
      cta: "Book a demo with this setup",
      restart: "Start over",
      tier_starter: "Starter",
      tier_grow: "Grow",
      tier_complete: "Complete",
      tier_freedom: "Freedom",
      step: "Step",
      of: "of",
      next: "Next",
      back: "Back",
      one_time_install: "+ one-time CHF 380 menu programming & installation",
    },
    compare_cta: {
      eyebrow: "vs Lightspeed",
      h2_a: "Same job.",
      h2_b: "Less noise.",
      h2_c: "Half the bill.",
      body: "O'javana is the focused, Swiss-built alternative to bloated global POS suites. No upsell waterfall, no ticket queues, no surprise hardware invoices.",
      cta: "Read the full comparison",
      cta2: "Book a 30-min demo",
      dim: "Dimension",
    },
    industries_page: {
      eyebrow: "Industries",
      h1_a: "One platform.",
      h1_b: "Six industries.",
      intro: "From kiosk-led QSRs to multi-brand franchises — same O'javana stack, different playbook.",
      book_demo_for: "Book a demo for",
    },
    industries_section: {
      restaurants_title: "Restaurants & Cafés",
      restaurants_body: "Front-of-house. Back-of-house. Online. All on one ticket.",
      retail_title: "Retail & Boutiques",
      retail_body: "Fast checkout, inventory that always reconciles, payments built-in.",
    },
    kiosk_section: {
      p1: "21\" & 27\" hardware ready to bolt down",
      p2: "Smart upsell engine, trained per menu",
      p3: "Apple Pay · Google Pay · EMV chip",
      p4: "Direct-to-kitchen ticket routing",
    },
    payments_section: {
      eyebrow: "Payment methods",
      h2: "Take every payment. Without the politics.",
      body_a: "We process payments in collaboration with",
      body_b: ". One contract. One device. Cards, contactless, TWINT and wallets — all tied straight to the POS.",
      coverage: "Coverage",
      coverage_title: "Works wherever Adyen accepts payments.",
      coverage_body: "From Zurich to Madrid to Helsinki — all of Europe in one acquiring contract.",
      compliance: "Compliance",
      compliance_title: "PCI DSS · 3-D Secure 2 · GDPR.",
      compliance_body: "Compliance is shipped, not configured. Fraud screening included.",
      ch_first: "Switzerland-first",
      ch_first_title: "TWINT, baked in.",
      ch_first_body: "Native TWINT on every kiosk, terminal and online checkout.",
    },
    demo_interests: {
      pos: "POS",
      kiosk: "Kiosk",
      online_shop: "Online Shop",
      qr_order: "QR Order & Pay",
      waiter_app: "Waiter App",
      payment: "Payment",
    },
    common: {
      close: "Close",
      error_submit: "Could not submit. Try again.",
    },
    seo: {
      service_area: "Service area",
      book_demo_in: "Book a demo in",
      book_demo: "Book a demo",
      request_callback: "Request a callback",
      configure_hardware: "Configure hardware",
      faq_title: "FAQ",
      faq_q1: "Does O'javana support TWINT?",
      faq_a1: "Yes — TWINT is native on every O'javana terminal, kiosk and online checkout. No plugin, no extra account.",
      faq_q2: "How fast can you install on-site?",
      faq_a2: "Within 48 hours across most Swiss cantons. Same-day in Canton Neuchâtel where our HQ is.",
      faq_q3: "What's the card processing rate?",
      faq_a3: "0.90% for all card payments when you pair O'javana with our Swisspayout-acquired terminals.",
      other_cities: "Other cities we serve",
      signal_response: "Response",
      signal_response_value: "Same hour",
      signal_onsite: "On-site",
      signal_onsite_value: "Within 48 h",
      signal_hosted: "Hosted",
      signal_hosted_value: "Swiss data centres",
      ours_label: "O'javana — what you get",
      them_label_suffix: "— what's missing",
      switch_from: "Switch from",
      see_pricing: "See our pricing",
      alt_faq_q1: "Can I migrate from {competitor} for free?",
      alt_faq_a1: "Yes — our team migrates your menu, products, customers and reports from {competitor} at no charge. Most stores switch within 48 hours.",
      alt_faq_q2: "Will I keep TWINT and contactless?",
      alt_faq_a2: "Native TWINT, Apple Pay, Google Pay, EMV chip and Tap-to-Pay on iPhone & Android — all included.",
      alt_faq_q3: "What's the monthly cost?",
      alt_faq_a3: "Starter from CHF 39/month with our terminal. No setup fees, no per-feature unlock.",
    },
  },
  de: {
    nav: {
      solutions: "Lösungen",
      industries: "Branchen",
      integrations: "Zahlungen",
      cases: "Referenzen",
      pricing: "Preise",
      blog: "Blog",
      configurator: "Konfigurator",
      contact: "Kontakt",
      talk: "Vertrieb sprechen",
      demo: "Demo buchen",
      callback: "Rückruf anfordern",
    },
    hero: {
      eyebrow: "KASSE · KIOSK · ONLINE-BESTELLUNG · ZAHLUNGEN",
      title_a: "Das Betriebssystem für",
      title_restaurants: "Gastronomie",
      title_and: "und",
      title_retail: "Handel",
      sub: "Eine Plattform für Kasse, Self-Order-Kiosks, QR-Bestellung, Online-Shop und Zahlungen. Schnell. Robust. Im Alltag erprobt.",
      cta_demo: "Demo buchen",
      cta_kiosks: "Kiosk entdecken",
      stat_live: "Live in",
      stat_uplift: "Ø Umsatzplus",
      stat_uptime: "Uptime",
      live_days: "5 Tagen",
    },
    sections: {
      why_overline: "Warum O'Javana",
      why_title: "Wie ein Werkzeug gebaut, nicht wie ein Spielzeug.",
      why_sub: "Jede Funktion hat im Betrieb einen Grund. Kein Ballast, kein Warten.",
      solutions_overline: "Lösungen",
      solutions_title: "Eine Plattform.",
      solutions_title_2: "Sechs Umsatzkanäle.",
      solutions_sub: "Module nach Bedarf kombinieren. Alles spricht mit der Kasse — keine Doppelerfassung.",
      kiosk_eyebrow: "Im Fokus · Kiosk",
      kiosk_title_a: "Selbstbedienungs-Kiosks, die sich in",
      kiosk_title_b: "6 Wochen",
      kiosk_title_c: "amortisieren.",
      kiosk_sub: "Schlangen reduzieren, Bonsumme um 22% steigern und das Team entlasten.",
      kiosk_cta: "Kiosk-Reihe ansehen",
      kiosk_cta2: "Kiosk-Demo buchen",
      dashboard_overline: "Live-Vorschau",
      dashboard_title: "Blick ins Cockpit.",
      dashboard_sub: "Genau die Oberfläche, die Dein Team im Service nutzt — Bestellungen, Menü, Auswertungen.",
      industries_overline: "Branchen",
      industries_title: "Auf Deinen Betrieb zugeschnitten.",
      industries_sub: "Vom Espresso-Bar bis zur Retail-Gruppe — gleiche Plattform, anderer Playbook.",
      integrations_overline: "Integrationen",
      integrations_title: "Spielt mit Deinem Stack zusammen.",
      integrations_sub: "Native Konnektoren für Zahlung, Lieferung, Buchhaltung und CRM — von uns gebaut und gepflegt.",
      testimonials_overline: "Vertraut",
      testimonials_title: "Betreiber, die mit O'Javana arbeiten.",
      logos_trusted: "Über 7.000 Betreiber in Europa vertrauen uns",
    },
    demo: {
      eyebrow: "Kostenlose Demo buchen",
      title: "In 30 Minuten auf Deiner Karte vorgeführt.",
      sub: "Keine Folien. Wir öffnen eine Sandbox mit Deiner Karte und zeigen Kasse + Kiosk + Online live.",
      bullets: [
        "Auf Deinen Betrieb zugeschnitten",
        "Hardware-Angebot im selben Gespräch",
        "Live-ROI-Rechner für Kiosks",
        "Onboarding-Scope auf Wunsch",
      ],
      full_name: "Vollständiger Name",
      business_name: "Betriebsname",
      email: "E-Mail",
      phone: "Telefon",
      business_type: "Betriebsart",
      locations: "Standorte",
      interested_in: "Interesse an",
      message: "Nachricht",
      submit: "Demo anfordern",
      sending: "Wird gesendet...",
      consent: "Mit dem Absenden stimmst Du unserem Datenschutzhinweis zu.",
      success_title: "Erhalten. Wir sind dran.",
      success_sub: "Ein Spezialist meldet sich innerhalb von 24 Stunden bei Dir.",
      success_again: "Weitere Anfrage senden",
      bt_restaurant: "Restaurant / Café",
      bt_retail: "Einzelhandel / Boutique",
      bt_kiosk: "QSR / Kiosk-getrieben",
      bt_events: "Events / Pop-up",
      bt_other: "Anderes",
      time_2min: "~2 Minuten",
    },
    callback: {
      eyebrow: "Rückruf anfordern",
      title: "Lieber zurückgerufen werden?",
      sub: "Hinterlasse Deine Nummer — wir rufen zur Wunschzeit zurück.",
      full_name: "Name",
      phone: "Telefon",
      topic: "Worum geht's? (optional)",
      best_time: "Wunschzeit",
      asap: "Sofort",
      morning: "Vormittag",
      afternoon: "Nachmittag",
      evening: "Abend",
      submit: "Rückruf anfordern",
      success: "Danke. Wir melden uns gleich.",
    },
    footer: {
      tagline: "Die All-in-One-Plattform für Kasse, Kiosk und Online-Bestellung — gebaut für Gastronomie und Handel.",
      newsletter_ph: "du@business.com",
      subscribe: "Abonnieren",
      solutions: "Lösungen",
      company: "Unternehmen",
      get_started: "Jetzt starten",
      privacy: "Datenschutz",
      terms: "AGB",
      imprint: "Impressum",
    },
    configurator: {
      title: "Hardware-Konfigurator",
      sub: "Stelle das Hardware-Bundle für Deinen Betrieb zusammen — transparentes Angebot in Sekunden.",
      total_hardware: "Hardware (einmalig)",
      total_software: "Software / Monat",
      cta_save: "Angebot speichern & senden",
      cta_call: "Vertrieb soll mich dazu zurückrufen",
      placeholder_full_name: "Anna Müller",
      placeholder_business: "Café Pivot",
      placeholder_email: "du@business.com",
      saved: "Angebot gespeichert. Prüfe Deinen Posteingang.",
    },
    admin: {
      title: "Admin · Posteingang",
      enter_token: "Passwort",
      token_label: "Passwort",
      token_help: "Der Browser kann E-Mail und Passwort speichern.",
      inbox_help: "Demo-Anfragen, Rückrufe, Offerten und CMS-Seiten. E-Mail und Passwort aus der Server-.env.",
      offers_login_link: "Offers, Gutscheine, Mailco-Einstellungen",
      email_label: "E-Mail",
      password_label: "Passwort",
      sign_in: "Anmelden",
      tab_demos: "Demo-Anfragen",
      tab_callbacks: "Rückrufe",
      tab_contacts: "Kontaktnachrichten",
      tab_quotes: "Konfigurator-Angebote",
      tab_pages: "Seiten",
      logout: "Abmelden",
      empty: "Noch nichts hier.",
      mark_contacted: "Kontaktiert",
      mark_qualified: "Qualifiziert",
      mark_won: "Gewonnen",
      mark_lost: "Verloren",
      invalid_token: "Ungültige E-Mail oder Passwort.",
      invalid_credentials: "Ungültige E-Mail oder Passwort.",
    },
    ...deSupplement,
  },
  fr: {
    nav: {
      solutions: "Solutions",
      industries: "Secteurs",
      integrations: "Paiements",
      cases: "Études de cas",
      pricing: "Tarifs",
      blog: "Blog",
      configurator: "Configurateur",
      contact: "Contact",
      talk: "Parler aux ventes",
      demo: "Réserver une démo",
      callback: "Demander un rappel",
    },
    hero: {
      eyebrow: "CAISSE · BORNE · COMMANDE EN LIGNE · PAIEMENTS",
      title_a: "Le système d'exploitation pour",
      title_restaurants: "restaurants",
      title_and: "et",
      title_retail: "commerce",
      sub: "Une plateforme pour la caisse, les bornes en libre-service, la commande QR, la boutique en ligne et les paiements. Rapide. Robuste. Pensée pour le terrain.",
      cta_demo: "Réserver une démo",
      cta_kiosks: "Découvrir les bornes",
      stat_live: "En ligne en",
      stat_uplift: "Hausse moyenne",
      stat_uptime: "Disponibilité",
      live_days: "5 jours",
    },
    sections: {
      why_overline: "Pourquoi O'Javana",
      why_title: "Conçu comme un outil, pas comme un jouet.",
      why_sub: "Chaque fonction a une raison d'être en service. Pas de superflu, pas d'attente.",
      solutions_overline: "Solutions",
      solutions_title: "Une plateforme.",
      solutions_title_2: "Six canaux de revenus.",
      solutions_sub: "Combinez les modules. Tout dialogue avec la caisse — zéro double saisie.",
      kiosk_eyebrow: "Focus · Borne",
      kiosk_title_a: "Des bornes en libre-service rentables en",
      kiosk_title_b: "6 semaines",
      kiosk_title_c: ".",
      kiosk_sub: "Réduisez les files, augmentez le ticket moyen de 22% et libérez vos équipes.",
      kiosk_cta: "Voir la gamme bornes",
      kiosk_cta2: "Réserver une démo borne",
      dashboard_overline: "Aperçu en direct",
      dashboard_title: "Au cœur du cockpit.",
      dashboard_sub: "Le tableau de bord utilisé par votre équipe en service — commandes, menu, analytics.",
      industries_overline: "Secteurs",
      industries_title: "Adapté à votre type d'activité.",
      industries_sub: "Du bar à expresso de 12 places à un groupe retail de 200 magasins — même plateforme, autre playbook.",
      integrations_overline: "Intégrations",
      integrations_title: "Compatible avec votre stack.",
      integrations_sub: "Connecteurs natifs pour paiement, livraison, comptabilité et CRM — construits et maintenus en interne.",
      testimonials_overline: "Confiance",
      testimonials_title: "Des opérateurs qui tournent sur O'Javana.",
      logos_trusted: "Plus de 7 000 opérateurs nous font confiance en Europe",
    },
    demo: {
      eyebrow: "Réserver une démo gratuite",
      title: "À l'œuvre sur votre menu en 30 minutes.",
      sub: "Pas de slides. On ouvre une sandbox avec votre carte et on déroule Caisse + Borne + Online.",
      bullets: [
        "Adapté à votre type d'activité",
        "Devis hardware dans le même appel",
        "Calculateur ROI bornes en direct",
        "Onboarding chiffré sur demande",
      ],
      full_name: "Nom complet",
      business_name: "Nom de l'entreprise",
      email: "E-mail",
      phone: "Téléphone",
      business_type: "Type d'activité",
      locations: "Nb. de sites",
      interested_in: "Intéressé par",
      message: "Message",
      submit: "Demander la démo",
      sending: "Envoi...",
      consent: "En soumettant vous acceptez notre politique de confidentialité.",
      success_title: "Bien reçu. On s'en occupe.",
      success_sub: "Un spécialiste vous recontacte sous 24 heures.",
      success_again: "Envoyer une autre demande",
      bt_restaurant: "Restaurant / Café",
      bt_retail: "Commerce / Boutique",
      bt_kiosk: "QSR / orienté borne",
      bt_events: "Événements / Pop-up",
      bt_other: "Autre",
      time_2min: "~2 minutes",
    },
    callback: {
      eyebrow: "Demander un rappel",
      title: "Vous préférez qu'on vous appelle ?",
      sub: "Laissez votre numéro, un spécialiste rappelle au moment voulu.",
      full_name: "Nom complet",
      phone: "Téléphone",
      topic: "Sujet ? (optionnel)",
      best_time: "Meilleur moment",
      asap: "Dès que possible",
      morning: "Matin",
      afternoon: "Après-midi",
      evening: "Soir",
      submit: "Demander le rappel",
      success: "Merci. On vous rappelle bientôt.",
    },
    footer: {
      tagline: "La plateforme tout-en-un Caisse, Borne et Commande en ligne — pensée pour la restauration et le commerce.",
      newsletter_ph: "vous@entreprise.com",
      subscribe: "S'abonner",
      solutions: "Solutions",
      company: "Société",
      product: "Produit",
      get_started: "Commencer",
      book_demo: "Réserver une démo",
      email_us: "Nous écrire",
      vs_sumup: "vs SumUp",
      vs_paymash: "vs Paymash",
      privacy: "Confidentialité",
      terms: "Conditions",
      imprint: "Mentions légales",
    },
    configurator: {
      title: "Configurateur de bundle matériel",
      sub: "Choisissez le matériel adapté à votre salle. Devis transparent en quelques secondes.",
      total_hardware: "Matériel (unique)",
      total_software: "Logiciel / mois",
      cta_save: "Enregistrer & m'envoyer ce devis",
      cta_call: "Demander un rappel sur ce bundle",
      placeholder_full_name: "Anna Müller",
      placeholder_business: "Café Pivot",
      placeholder_email: "vous@entreprise.com",
      saved: "Devis enregistré. Vérifiez votre boîte mail.",
    },
    admin: {
      title: "Admin · Boîte de réception",
      enter_token: "Mot de passe",
      token_label: "Mot de passe",
      token_help: "Le navigateur peut enregistrer cet e-mail et ce mot de passe.",
      inbox_help: "Demandes de démo, rappels, devis et pages CMS. E-mail et mot de passe depuis le .env du serveur.",
      offers_login_link: "Offres, bons, réglages Mailco",
      email_label: "E-mail",
      password_label: "Mot de passe",
      sign_in: "Se connecter",
      tab_demos: "Demandes de démo",
      tab_callbacks: "Rappels",
      tab_contacts: "Messages de contact",
      tab_quotes: "Devis configurateur",
      tab_pages: "Pages",
      logout: "Se déconnecter",
      empty: "Rien pour l'instant.",
      mark_contacted: "Contacté",
      mark_qualified: "Qualifié",
      mark_won: "Gagné",
      mark_lost: "Perdu",
      invalid_token: "E-mail ou mot de passe invalide.",
      invalid_credentials: "E-mail ou mot de passe invalide.",
    },
    header: {
      home: "Accueil",
      product: "Produit",
      industries: "Secteurs",
      offers: "Offres",
      see_all_products: "Voir tous les produits",
    },
    footer_extra: {
      contact_us: "Nous contacter",
      offices: "Neuchâtel · Manchester · Fribourg",
      subscribed: "Inscrit.",
      could_not_subscribe: "Impossible de s'abonner. Réessayez.",
      rights: "Tous droits réservés.",
      website_by: "Site réalisé par",
    },
    banner: {
      office_open: "Bureau de Boudry ouvert · 08:00–19:00 CET",
    },
    neuchatel: {
      eyebrow: "Né en Suisse",
      title_a: "Conçu à",
      title_b: "Neuchâtel",
      title_c: "pour le marché suisse.",
      desc: "O'javana est exploité depuis Boudry, canton de Neuchâtel, en Suisse. Nos ingénieurs, agents de support et techniciens terrain parlent votre langue, connaissent votre marché et répondent quand vous appelez.",
      stat_response: "Réponse",
      stat_response_value: "Dans l'heure",
      stat_onsite: "Sur site",
      stat_onsite_value: "Sous 48 h",
      stat_hosted: "Hébergé",
      stat_hosted_value: "Centres de données suisses",
      cta_talk: "Parler à un spécialiste local",
      cta_callback: "Demander un rappel",
      hq_label: "/siège · suisse",
      hq_name: "Boudry",
      geo_line: "50 minutes de Berne · 90 minutes de Zurich et Genève.",
      hours_label: "Heures d'ouverture",
      hours_value: "08:00 – 19:00 CET",
      langs_label: "Langues",
      langs_value: "FR · DE · EN · IT",
    },
    whypage: {
      counter: "Depuis Neuchâtel · 234 établissements en service",
      eyebrow: "Pourquoi O'javana",
      h1_a: "Facile à utiliser,",
      h1_b: "moins cher",
      h1_c: ", efficace &",
      h1_d: "support local",
      h1_e: ".",
      intro: "Les solutions moins chères et non locales vous font économiser un peu — et vous épuisent. Quand quelque chose casse, vous courez après eux. Avec O'javana, l'équipe est en Suisse, le téléphone est décroché et votre salle continue de tourner.",
      cta_h2_a: "Visitez notre showroom à",
      cta_h2_b: "Boudry",
      cta_h2_c: "dès aujourd'hui !",
      cta_body: "Passez prendre un café au bureau et découvrez le produit en conditions réelles.",
      book_visit: "Réserver votre visite",
      see_pricing: "Voir les tarifs",
      easy_title: "Facile à utiliser",
      easy_body: "Formez votre équipe en 12 minutes — pas en 12 jours. Grandes tuiles, parcours clairs, aucun manuel à lire. Le genre de caisse que votre renfort du week-end maîtrise avant midi.",
      easy_p1: "Saisie d'une commande en moins d'une seconde",
      easy_p2: "Formation du personnel en 12 minutes",
      easy_p3: "Grandes tuiles tactiles, pas de menus imbriqués",
      easy_p4: "Même UI sur caisse, borne et terminal mobile",
      cheaper_title: "Matériel moins cher",
      cheaper_body: "Démarrage à CHF 39/mois avec notre terminal. Les commerçants éligibles reçoivent le bundle caisse et même la borne en libre-service sans frais initiaux.",
      cheaper_p1: "CHF 0 de matériel pour les commerçants éligibles",
      cheaper_p2: "0,90 % de commission avec nos terminaux",
      cheaper_p3: "Borne 23,8\" à CHF 1 980",
      cheaper_p4: "Aucun module à débloquer, aucun frais d'installation",
      efficient_title: "Efficace",
      efficient_body: "Caisse offline-first, analyses en temps réel et passage en cuisine qui ne dépend pas d'un aller-retour cloud. Conçue pour la rush du vendredi 20 h.",
      efficient_p1: "Offline-first — aucune vente ratée",
      efficient_p2: "Tableau de bord multi-sites en temps réel",
      efficient_p3: "Kitchen Display + Customer Display inclus",
      efficient_p4: "UberEats, QR & en ligne — un seul ticket",
      local_title: "Support local",
      local_body: "De vraies personnes à Neuchâtel — pas de centre d'appel à l'étranger, pas de file d'attente, pas d'attente d'une semaine. Réponse dans l'heure et intervention sur site sous 48 h.",
      local_p1: "Exploité depuis Neuchâtel · Suisse",
      local_p2: "Réponse dans l'heure, correction le jour même",
      local_p3: "Intervention sur site sous 48 h",
      local_p4: "Téléphone en FR · DE · EN · IT",
    },
    payments_page: {
      eyebrow: "Paiements",
      h1: "Tout accepter. Rien à rapprocher.",
      intro_a: "Grâce à notre collaboration avec Swisspayout, chaque terminal, borne et caisse en ligne O'javana accepte les cartes, le sans contact, TWINT et les principaux portefeuilles mobiles — réglés sur un seul compte. Pour plus de détails, consultez",
    },
    sitemap_page: {
      eyebrow: "Plan du site",
      h1: "Chaque page d'O'javana.",
      intro: "Une seule vue, toutes les routes. Une référence utile pour les humains et un signal propre pour les moteurs de recherche.",
      sec_discover: "Découvrir",
      sec_product: "Produit",
      sec_industries: "Secteurs",
      sec_pricing_tools: "Tarifs & Outils",
      sec_contact: "Contact",
      sec_legal: "Mentions légales",
      lbl_home: "Accueil",
      lbl_why: "Pourquoi O'javana",
      lbl_about: "À propos",
      lbl_industries_all: "Secteurs",
      lbl_case_studies: "Études de cas",
      lbl_blog: "Blog",
      lbl_vs_ls: "vs Lightspeed",
      lbl_pos: "Caisse enregistreuse",
      lbl_kiosk: "Borne en libre-service",
      lbl_waiter: "App serveur",
      lbl_qr: "Commande & Paiement QR",
      lbl_shop: "Boutique en ligne",
      lbl_terminals: "Terminaux de paiement",
      lbl_loyalty: "Cartes cadeaux & Fidélité",
      lbl_all_products: "Tous les produits",
      lbl_qsr: "Restauration rapide",
      lbl_delivery: "Service de livraison",
      lbl_restaurants: "Restaurants & Cafés",
      lbl_grocery: "Épicerie & Proximité",
      lbl_foodtruck: "Food truck",
      lbl_franchise: "Franchise & Multi-marque",
      lbl_pricing: "Tarifs",
      lbl_offers: "Offres",
      lbl_configurator: "Configurateur de prix",
      lbl_payments: "Paiements",
      lbl_contact: "Contact",
      lbl_callback: "Demander un rappel",
      lbl_book_demo: "Réserver une démo",
      lbl_imprint: "Mentions légales",
      lbl_privacy: "Confidentialité",
      lbl_terms: "Conditions",
      lbl_sitemap: "Plan du site",
      sec_cities: "Villes — Caisse",
      sec_service_areas: "Zones de service",
      sec_alternatives: "Alternatives",
      sec_seo_solutions: "Solutions (SEO)",
      lbl_pos_in: "Caisse",
      lbl_alt_suffix: "Alternative à",
    },
    contact_page: {
      eyebrow: "Contact",
      h1: "Parlez à celles et ceux qui l'ont construit.",
      intro: "Envoyez-nous un mot et un spécialiste suisse vous recontacte sous une heure ouvrée. Ou appelez — on décroche.",
      address: "Rue Louis-Favre 12 · 2017 Boudry · Suisse",
      time_hint: "~1 minute",
      f_full_name: "Nom complet",
      f_phone: "Téléphone",
      f_email: "E-mail",
      f_message: "Message",
      ph_full_name: "Anna Müller",
      ph_phone: "+41 79 000 00 00",
      ph_email: "vous@entreprise.com",
      ph_message: "Parlez-nous de votre activité et de la façon dont nous pouvons aider.",
      agree: "En soumettant, vous acceptez notre politique de confidentialité.",
      send: "Envoyer le message",
      sending: "Envoi...",
      success_title: "Bien reçu.",
      success_body: "Un spécialiste vous répond sous une heure ouvrée.",
      send_another: "Envoyer un autre message",
      toast_success: "Merci. Nous revenons vers vous rapidement.",
      toast_error: "Envoi impossible. Réessayez.",
    },
    pricing_page: {
      eyebrow: "Tarifs",
      h1_a: "Une plateforme.",
      h1_b: "Des tarifs imbattables.",
      intro_a: "Aucun frais d'installation. Aucun déblocage par fonction. Commission à",
      intro_b_with: "avec les terminaux de paiement O'javana",
      intro_b_without: "en Starter sans notre terminal",
      banner_eligible: "Commerçants éligibles",
      banner_h2_a: "Matériel offert si vos ventes par carte dépassent",
      banner_h2_amount: "CHF 20 000/mois",
      banner_h2_z: ".",
      banner_body: "Traitez plus de CHF 20 000 par mois en paiements carte et nous vous livrons votre terminal de caisse, terminal de paiement, imprimante et caisse-tiroir sans frais initiaux. Sur le plan Freedom, la borne 23,8\" est incluse dans la même éligibilité — combinée à notre",
      banner_rate_phrase: "taux spécial de 0,90 %",
      banner_pt1: "Engagement 12 mois, remplacement fair-use inclus",
      banner_pt2: "Éligibilité revue chaque mois — pas de frais cachés",
      banner_pt3: "Suisse, UE et marchés couverts par Adyen",
      banner_check: "Vérifier mon éligibilité",
      banner_callback: "Demander un rappel",
      banner_bundle_caption: "Bundle standard : POS double écran, caisse-tiroir, imprimante 80 mm, terminal EMV/NFC/TWINT.",
      hw_sw_label: "matériel + logiciel",
      toggle_terminal: "Avec terminal de paiement O'javana",
      toggle_terminal_caption: "−30 CHF / mois · taux carte 0,90 %",
      toggle_yearly: "Facturation annuelle",
      toggle_yearly_caption: "2 mois offerts · payez 10× le mensuel",
      most_chosen: "Le plus choisi",
      per_yr: "/an",
      per_mo: "/mois",
      per_station: "· par poste",
      with_term_save: "−CHF 30 avec notre terminal",
      two_months_free: "2 mois offerts vs mensuel",
      premium_kiosk_led: "Premium · Orienté borne",
      freedom_meta: "/freedom · abonnement",
      freedom_kiosk_note: "Matériel borne (23,8\") offert pour les commerçants éligibles dépassant CHF 20K de ventes carte/mois avec les terminaux O'javana.",
      freedom_cta: "Choisir Freedom",
      freedom_fixed: "Tarif bundle fixe · ne change pas avec le terminal",
      plan_includes: "Tous les plans incluent commandes illimitées, conformité PCI & RGPD, hébergement suisse, garantie 30 jours satisfait ou remboursé et mises à jour transparentes. Matériel Borne 23,8\" :",
      plan_includes_unit: "par unité (ou gratuit avec Freedom sous éligibilité).",
      kds_cds_footnote: "* Le Kitchen Display System (KDS) 15,6\" et le Customer Display System (CDS) 10\" sont disponibles en option sur tous les plans, y compris Complete — CHF 480 (KDS) et CHF 220 (CDS) par unité.",
      addon_label: "Matériel additionnel",
      addon_h2_a: "Borne 23,8\" ·",
      addon_body: "Borne sur comptoir ou autoportante avec paiement TWINT, imprimante de tickets et scanner de codes-barres. Offerte avec l'abonnement Freedom sous éligibilité ventes-carte mensuelles.",
      addon_p1: "Écran tactile 23,8\" anti-reflet",
      addon_p2: "Terminal EMV/NFC/TWINT intégré",
      addon_p3: "Imprimante de tickets 80 mm intégrée",
      addon_p4: "Scanner de codes-barres 1D/2D intégré",
      addon_p5: "Kitchen Display System (KDS) 15,6\" · CHF 480",
      addon_cta_cfg: "Configurer mon bundle matériel",
      addon_cta_kiosk: "Découvrir la borne",
      starter_name: "Starter",
      starter_blurb: "Vraie caisse cloud opérationnelle cette semaine. Acceptez les cartes, gérez les shifts, clôturez proprement.",
      starter_cta: "Commencer avec Starter",
      grow_name: "Grow",
      grow_blurb: "Ajoutez l'app serveur et la commande à table. Le set-up que la plupart des cafés utilisent.",
      grow_cta: "Choisir Grow",
      complete_name: "Complete",
      complete_blurb: "Multi-poste, multi-site, tous les canaux — le cockpit opérationnel complet.",
      complete_cta: "Choisir Complete",
      freedom_name: "Freedom",
      freedom_blurb: "Établissements orientés borne. Le bundle Complete plus la borne 23,8\" — incluse.",
    },
    configurator_page: {
      hardware_label: "Matériel",
      important: "Important",
      tier_intro: "Vos ventes carte mensuelles",
      with_term_label: "Avec terminal de paiement O'javana",
      with_term_caption: "Licence −CHF 30 / mois par poste",
      note_tier_rental: "Le client doit maintenir les ventes mentionnées pendant 6 mois consécutifs pour conserver le tarif remisé (ou le matériel offert). Le prix du matériel payé sera remboursé sous forme de mensualités de licence logicielle offertes (équivalent au montant matériel) ou sous forme de bon d'achat.",
      note_rate: "Assurance mensuelle optionnelle + frais de carte SIM pour les terminaux de paiement : CHF 29 / mois pour S1F2 et CHF 19 / mois pour AMS1, facturée annuellement.",
      note_install: "Programmation du menu & installation sur place : frais unique de CHF 380.",
      book_demo_link: "Ou réserver une démo en direct →",
      free_label: "OFFERT",
      free_eligible: "offert sur le bundle POS",
      stations_label: "postes",
      per_station_save: "−CHF 30 / poste avec terminal",
      bundle_label: "Ajouter le bundle POS",
      bundle_reset: "Réinitialiser le bundle",
      bundle_caption: "POS · Terminal AMS1 · Imprimante de tickets · Caisse-tiroir",
      bundle_only: "Offert sur le bundle POS uniquement",
      pos_bundle_table: "Bundle POS",
      pos_bundle_table_caption: "Offert au palier 100 % · remisé aux autres paliers",
      optional_hw_table: "Matériel optionnel",
      optional_hw_table_caption: "Remisé aux paliers 30 / 40 / 50 % · plein tarif au palier 100 %",
      tier_t0: "Moins de CHF 5 000",
      tier_t1: "CHF 5 000 – 10 000",
      tier_t2: "CHF 10 000 – 15 000",
      tier_t3: "CHF 15 000 – 20 000",
      tier_t4: "CHF 20 000+",
      mobile_quote: "Devis",
      mobile_view_full: "Toucher pour voir le devis complet",
    },
    offers: {
      nav: "Offres",
      eyebrow: "Promotions à durée limitée",
      h1: "Des offres qui donnent envie de changer.",
      intro: "Sélection d'offres O'javana — remises nouveaux clients, matériel offert, packs saisonniers. À saisir avant expiration.",
      empty_title: "Aucune offre en cours pour l'instant.",
      empty_body: "Revenez bientôt — ou réservez une démo et on vous en concocte une.",
      free: "Offert",
      view: "Voir l'offre",
      days_left: "{n} jours restants",
      all_offers: "Toutes les offres",
      details: "À propos de cette offre",
      terms: "Conditions générales",
      valid_until: "Valable jusqu'au {date}",
      other_offers: "Autres offres en cours",
      not_found: "Cette offre n'existe pas.",
      expired_banner: "Cette offre n'est plus disponible. Découvrez nos autres offres.",
      check_others: "Voir les offres en cours",
      claim_this_offer: "Réclamer cette offre",
      full_name: "Votre nom complet",
      email: "Votre e-mail",
      phone: "Numéro de téléphone",
      business_name: "Nom de l'entreprise (facultatif)",
      have_code: "Vous avez un code ?",
      voucher_ph: "Entrez le code (facultatif)",
      submit: "Envoyer ma demande",
      sending: "Envoi...",
      privacy_hint: "Vos coordonnées servent uniquement au traitement de cette offre. Jamais revendues ni spammées.",
      success_title: "Merci — demande reçue.",
      success_body: "Nous vous recontactons sous un jour ouvré avec les prochaines étapes.",
      popup_cta: "Profiter de l'offre →",
      cta_headline: "Pour profiter de cette offre, remplissez le formulaire ci-dessous.",
      cta_sub: "Nous confirmons sous un jour ouvré. Ou payez directement en dessous du formulaire.",
      or: "ou",
      buy_now_title: "Envie d'acheter cette offre immédiatement ?",
      buy_now_sub: "Payez par carte ou Apple Pay en quelques secondes. Vos données sont protégées par Adyen.",
      you_pay: "Vous payez",
      pay_now: "Acheter maintenant",
      buy_direct_headline: "Achetez cette offre instantanément.",
      buy_direct_sub: "Renseignez vos coordonnées ci-dessous, payez par carte ou Twint, et nous activons votre offre.",
      your_details: "Vos coordonnées",
      ask_pill: "Une question ?",
      ask_headline: "Pas prêt à acheter ? Remplissez le formulaire ci-dessous et nous vous recontactons.",
      ask_sub: "Envoyez-nous vos questions ou besoins spécifiques — réponse sous un jour ouvré.",
      claim_headline_no_pay: "Pour profiter de cette offre, remplissez le formulaire ci-dessous.",
      claim_sub_no_pay: "Nous vous confirmons sous un jour ouvré avec les prochaines étapes.",
      fill_contact_first: "Remplissez d'abord votre nom, e-mail et téléphone.",
      voucher_invalid: "Code non reconnu — vous pouvez continuer sans code.",
    },
    solutions_page: {
      eyebrow_all: "Toutes les solutions",
      h1_a: "Composez la stack adaptée à",
      h1_b: "votre salle.",
      intro: "Chaque module est livré seul ou dans la suite tout-en-un. Combinez ce dont vous avez besoin.",
      back: "← Retour aux solutions",
      book_demo: "Réserver une démo",
      configure_hardware: "Configurer le matériel",
      what_you_get: "Ce que vous obtenez",
      pairs_with: "Se marie bien avec",
    },
    compare_page: {
      pill: "Comparatif Made in Switzerland",
      h1_a: "O'javana vs",
      h1_ls: "Lightspeed",
      h1_b: "Le choix local et concentré.",
      intro: "Lightspeed est une suite globale très correcte. Mais si vous gérez un restaurant ou un commerce en Suisse, vous n'avez pas besoin de 200 fonctions et d'une file de tickets — il vous faut une caisse qui marche, avec une équipe qui décroche.",
      side_by_side: "Côte à côte",
      full_picture: "La vue d'ensemble.",
      vp_honest_title: "Tarification honnête",
      vp_honest_body: "Starter à CHF 39/mois avec notre terminal. Aucun frais d'installation, aucun déblocage par fonction, aucun add-on surprise. Taux carte à 0,90 % avec les terminaux O'javana.",
      vp_focused_title: "Produit focalisé",
      vp_focused_body: "Caisse, bornes, en ligne, paiements, cartes cadeaux & fidélité, stocks — c'est tout. Pas de menu de 200 options inutiles.",
      vp_local_title: "Support local suisse",
      vp_local_body: "Réponse dans l'heure. Correction le jour-même. Intervention sous 48 h. Une vraie équipe à Neuchâtel — pas une file de tickets globale.",
      vp_hw_title: "Matériel offert pour les commerçants éligibles",
      vp_hw_body: "Plus de CHF 20 000 de ventes carte par mois ? Bundle POS, terminal de paiement et borne en libre-service livrés sans frais initiaux.",
      dim: "Dimension",
      footnote: "Comparatif basé sur les tarifs publics Lightspeed Retail / Restaurant et leur bundle matériel au moment de la rédaction. Votre devis effectif peut varier.",
      bottom_h2: "Vous souhaitez migrer depuis Lightspeed ?",
      bottom_body: "Nous migrons votre menu, vos produits et vos rapports gratuitement. Installation sous 48 h, terminaux expédiés le jour-même pour les commerçants éligibles.",
      bottom_cta: "Réserver un audit de migration",
      bottom_cta2: "Voir nos tarifs",
    },
    eligibility: {
      eyebrow: "Test d'éligibilité en 30 secondes",
      title: "Trouvez votre palier en 30 secondes.",
      subtitle: "Quatre questions rapides — nous vous suggérons le plan, la remise terminal, l'éligibilité au bundle matériel et votre facture estimée du premier mois.",
      q1: "Quelles sont vos ventes carte mensuelles ?",
      q1_t0: "Moins de CHF 5 000",
      q1_t1: "CHF 5 000 – 10 000",
      q1_t2: "CHF 10 000 – 15 000",
      q1_t3: "CHF 15 000 – 20 000",
      q1_t4: "CHF 20 000+",
      q2: "Combien de postes de caisse ?",
      q3: "Où se trouve votre établissement ?",
      q3_ch: "Suisse",
      q3_eu: "UE (couverte par Adyen)",
      q3_other: "Autre",
      q4: "Utilisez-vous déjà une caisse aujourd'hui ?",
      q4_yes: "Oui, je migre",
      q4_no: "Non, nouvelle ouverture",
      result_eyebrow: "Configuration recommandée",
      result_plan: "Plan",
      result_terminal: "Avec terminal de paiement O'javana",
      result_bundle: "Matériel bundle POS",
      result_invoice: "Facture estimée du premier mois",
      bundle_free: "Offert pour les commerçants éligibles",
      bundle_paid: "CHF 1 065 unique",
      bundle_freedom: "Borne + bundle POS offerts",
      ineligible: "Nous couvrons actuellement la Suisse et les marchés UE supportés par Adyen. Contactez-nous quand même — nous vous trouverons un partenaire.",
      cta: "Réserver une démo avec cette config",
      restart: "Recommencer",
      tier_starter: "Starter",
      tier_grow: "Grow",
      tier_complete: "Complete",
      tier_freedom: "Freedom",
      step: "Étape",
      of: "sur",
      next: "Suivant",
      back: "Précédent",
      one_time_install: "+ frais unique de CHF 380 (programmation menu & installation)",
    },
    compare_cta: {
      eyebrow: "vs Lightspeed",
      h2_a: "Même boulot.",
      h2_b: "Moins de bruit.",
      h2_c: "La moitié de la facture.",
      body: "O'javana est l'alternative focalisée et suisse aux suites POS globales boursouflées. Pas de cascade d'upsell, pas de file de tickets, pas de facture matériel surprise.",
      cta: "Lire le comparatif complet",
      cta2: "Réserver une démo de 30 min",
      dim: "Dimension",
    },
    industries_page: {
      eyebrow: "Secteurs",
      h1_a: "Une plateforme.",
      h1_b: "Six secteurs.",
      intro: "Du QSR orienté borne aux franchises multi-marques — même stack O'javana, autre playbook.",
      book_demo_for: "Réserver une démo pour",
    },
    industries_section: {
      restaurants_title: "Restaurants & Cafés",
      restaurants_body: "Salle. Cuisine. En ligne. Un seul ticket.",
      retail_title: "Commerce & Boutiques",
      retail_body: "Encaissement rapide, stocks toujours rapprochés, paiement intégré.",
    },
    kiosk_section: {
      p1: "Matériel 21\" & 27\" prêt à boulonner",
      p2: "Moteur d'upsell intelligent, paramétré par menu",
      p3: "Apple Pay · Google Pay · EMV puce",
      p4: "Routage direct vers la cuisine",
    },
    payments_section: {
      eyebrow: "Moyens de paiement",
      h2: "Acceptez tous les paiements. Sans la politique.",
      body_a: "Nous traitons les paiements en collaboration avec",
      body_b: ". Un contrat. Un appareil. Cartes, sans contact, TWINT et portefeuilles — directement rattachés à la caisse.",
      coverage: "Couverture",
      coverage_title: "Fonctionne partout où Adyen accepte les paiements.",
      coverage_body: "De Zurich à Madrid et Helsinki — toute l'Europe en un seul contrat d'acquisition.",
      compliance: "Conformité",
      compliance_title: "PCI DSS · 3-D Secure 2 · RGPD.",
      compliance_body: "La conformité est livrée, pas configurée. Filtrage de fraude inclus.",
      ch_first: "Priorité Suisse",
      ch_first_title: "TWINT, par défaut.",
      ch_first_body: "TWINT natif sur chaque borne, terminal et paiement en ligne.",
    },
    demo_interests: {
      pos: "Caisse",
      kiosk: "Borne",
      online_shop: "Boutique en ligne",
      qr_order: "Commande & paiement QR",
      waiter_app: "App serveur",
      payment: "Paiement",
    },
    common: {
      close: "Fermer",
      error_submit: "Envoi impossible. Réessayez.",
    },
    seo: {
      service_area: "Zone de service",
      book_demo_in: "Réserver une démo à",
      book_demo: "Réserver une démo",
      request_callback: "Demander un rappel",
      configure_hardware: "Configurer le matériel",
      faq_title: "FAQ",
      faq_q1: "O'javana prend-il en charge TWINT ?",
      faq_a1: "Oui — TWINT est natif sur chaque terminal, borne et paiement en ligne O'javana. Sans plugin, sans compte supplémentaire.",
      faq_q2: "Combien de temps prend l'installation sur site ?",
      faq_a2: "Sous 48 heures dans la plupart des cantons suisses. Le jour-même dans le canton de Neuchâtel où se trouve notre siège.",
      faq_q3: "Quelle est la commission carte ?",
      faq_a3: "0,90 % sur tous les paiements carte lorsque vous associez O'javana à nos terminaux acquis via Swisspayout.",
      other_cities: "Autres villes desservies",
      signal_response: "Réponse",
      signal_response_value: "Dans l'heure",
      signal_onsite: "Sur site",
      signal_onsite_value: "Sous 48 h",
      signal_hosted: "Hébergé",
      signal_hosted_value: "Centres de données suisses",
      ours_label: "O'javana — ce que vous obtenez",
      them_label_suffix: "— ce qui manque",
      switch_from: "Migrer depuis",
      see_pricing: "Voir nos tarifs",
      alt_faq_q1: "Puis-je migrer depuis {competitor} gratuitement ?",
      alt_faq_a1: "Oui — notre équipe migre votre menu, vos produits, vos clients et vos rapports depuis {competitor} sans frais. La plupart des établissements migrent en 48 heures.",
      alt_faq_q2: "Vais-je garder TWINT et le sans contact ?",
      alt_faq_a2: "TWINT, Apple Pay, Google Pay, EMV et Tap-to-Pay sur iPhone & Android — tout est inclus, en natif.",
      alt_faq_q3: "Quel est le coût mensuel ?",
      alt_faq_a3: "Starter à partir de CHF 39/mois avec notre terminal. Aucun frais d'installation, aucun déblocage par fonction.",
    },
  },
};

export function get(locale, path, fallback = "") {
  const parts = path.split(".");
  let cur = translations[locale] || translations.en;
  for (const p of parts) {
    cur = cur && cur[p];
    if (cur == null) break;
  }
  if (cur == null) {
    let f = translations.en;
    for (const p of parts) {
      f = f && f[p];
      if (f == null) break;
    }
    cur = f ?? fallback;
  }
  return cur;
}
